
const htmlfilter = (content)=> {
    content = content || "";
    content = content.replace(/<\!\-\-\[if[^>]+>[\w\W]+?\<\!\[endif\]\-\-\>/gi, "");
    content = content.replace(/<script[^>]*>[\w\W]*<\/script>/gi, "");
    content = content.replace(/<script[^>]*>[\w\W]*<\//gi, "");
    content = content.replace(/<style[^>]*>[\w\W]*<\/style>/gi, "");
    content = content.replace(/<style[^>]*>[\w\W]*<\//gi, "");
    content = content.replace(/<script[^>]*>/gi, "");
    content = content.replace(/<\/script>/gi, "");
    content = content.replace(/<style[^>]*>/gi, "");
    content = content.replace(/<\/style>/gi, "");
    content = content.replace(/<[^>]+>/gi, "");
    content = content.replace(/&[a-z]{1,6};/gi, "");
    return content;
}

export { htmlfilter }